export function parseGameScore(score) {
    const match = score.match(/^([A-Z0-9]+)\s+(\d+)[–-](\d+)\s+([A-Z0-9]+)\s+·\s+(.+)$/);
    if (!match) {
        return null;
    }
    const [, awayCode, awayScore, homeScore, homeCode, stateText] = match;
    const [state, clock = null] = stateText.split(" · ");
    return {
        awayCode,
        awayScore,
        clock,
        homeCode,
        homeScore,
        state,
    };
}
export function isInProgressGameScore(score) {
    const parsed = parseGameScore(score);
    return parsed ? /^(?:Q[1-4]|OT\d*)$/i.test(parsed.state) : false;
}
export function isLiveAvailabilityPhase(phase) {
    return ["anchor", "at-anchor", "live", "post-anchor"].includes(phase);
}
